module.exports = __webpack_public_path__ + "static/media/no-refunded.4635eab0.svg";